/*
  notifications
*/
/**
 * Desktop/mobile notifications management
 */
 /************************************************
          SHOW / HIDE notifs
 *************************************************/

 __notif = {

   init: function() {

     //-- get GROUP OPTIONS
     var options = $('[data-kind=GROUP_OPTION][data-type=notification]');

     //-- if options found
     if (options.length > 0) {

       //-- loop on them
       options.each(function e_loop_notif_options() {

         //-- init
         var option = $(this);

         //-- get notification name
         var name = option.attr("data-name");

         //-- show corresponding element in the page
         $('[data-notif='+name+']').show();
       });

       $('[data-nonotif]').hide();
     }
     else {
       $('[data-nonotif]').show();
       $('[data-notif]').hide();
     }
   },
 };

//-- init
 __notif.init();
